import { IdealRoleProvider } from "./IdealRoleJourneyContext";
import RoleDetails from "./IdealRoleDetails";
import Responsibility from "./IdealRoleRequirements";
import Journey from "../../Layouts/Journey";
import CV from "./IdealRoleCV";

export default Journey({ journeyTitle: "Journey to Your Ideal Job", Provider: IdealRoleProvider, finalRoute: "/#ideal-job" }, RoleDetails, Responsibility, CV);